// ===== Mega Menu Config
window.MEGA_MENU_CONFIG = {
  HOVER_DELAY_MS: 300 // delay before opening on hover
};

(function () {
  const nav    = document.querySelector('.mega-nav');
  if (!nav) return;

  const items  = nav.querySelectorAll('.mega-nav__item');
  const panels = nav.querySelectorAll('.mega-panel');

  const cfg = window.MEGA_MENU_CONFIG || {};
  const HOVER_DELAY_MS = cfg.HOVER_DELAY_MS || 300;

  // Track per-trigger hover timers
  const hoverTimers = new WeakMap();
  let lastTrigger = null;

  const within = (root, el) => !!(el && (root === el || root.contains(el)));

  // 1. Accessibility Helper: Keep hidden panels out of the tab order
  function setPanelInert(panel, inertOn) {
    panel.setAttribute('aria-hidden', inertOn ? 'true' : 'false');
    if ('inert' in panel) {
      panel.inert = !!inertOn;
    } else {
      // Fallback for older browsers
      panel.querySelectorAll('a,button,input,[tabindex]:not([tabindex="-1"])')
        .forEach(el => el.tabIndex = inertOn ? -1 : 0);
    }
  }

  // 2. OPEN Panel
  function openPanel(panelId, trigger, { moveFocus = true } = {}) {
    lastTrigger = trigger || lastTrigger;

    // Update triggers' state
    items.forEach(btn => btn.setAttribute('aria-expanded', btn.dataset.panel === panelId ? 'true' : 'false'));

    panels.forEach(panel => {
      if (panel.id === panelId) {
        panel.hidden = false;
        setPanelInert(panel, false);

        requestAnimationFrame(() => {
          panel.classList.add('is-open');
          
          // Only force focus if explicitly asked (e.g. Click/Enter), 
          // otherwise let the user Tab in naturally.
          if (moveFocus) {
             const firstInput = panel.querySelector('.sidebar-link.is-active') || 
                                panel.querySelector('.sidebar-link') || 
                                panel.querySelector('a, button'); // Fallback for no-sidebar panels
             if (firstInput) firstInput.focus();
          }
        });
      } else {
        // Close others immediately
        if (panel.classList.contains('is-open')) {
          closeSinglePanel(panel, { returnFocus: false });
        } else {
          panel.hidden = true;
          setPanelInert(panel, true);
        }
      }
    });
  }

  // 3. CLOSE All Panels
  function closePanels({ returnFocus = false } = {}) {
    panels.forEach(p => {
      if (p.classList.contains('is-open')) {
        closeSinglePanel(p, { returnFocus: false });
      }
    });
    items.forEach(btn => btn.setAttribute('aria-expanded', 'false'));
    if (returnFocus && lastTrigger) lastTrigger.focus();
  }

  // Close single helper (with transition)
  function closeSinglePanel(panel, { returnFocus = false } = {}) {
    if (!panel.classList.contains('is-open')) {
      panel.hidden = true;
      setPanelInert(panel, true);
      return;
    }

    panel.classList.remove('is-open');

    const onEnd = (e) => {
      if (e.propertyName !== 'opacity') return;
      panel.removeEventListener('transitionend', onEnd);
      panel.hidden = true;
      setPanelInert(panel, true);
      if (returnFocus && lastTrigger) lastTrigger.focus();
    };
    panel.addEventListener('transitionend', onEnd);

    // Safety fallback
    setTimeout(() => {
      if (!panel.hidden && !panel.classList.contains('is-open')) {
        panel.hidden = true;
        setPanelInert(panel, true);
      }
    }, 400); 
  }

  // 4. Sidebar Switching Logic (For Brands/Chassis panels)
  function activateSidebar(btn) {
    const panel = btn.closest('.mega-panel'); if (!panel) return;

    // Toggle Sidebar Buttons
    panel.querySelectorAll('.sidebar-link').forEach(s => {
      const active = s === btn;
      s.classList.toggle('is-active', active);
      s.setAttribute('aria-current', active ? 'true' : 'false');
    });

    // Toggle Content Grids
    const key = btn.getAttribute('data-cat');
    panel.querySelectorAll('.content-grid').forEach(grid => {
      const isVisible = grid.getAttribute('data-content') === key || grid.id === `content-${key}`;
      grid.classList.toggle('is-visible', isVisible);
      grid.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
    });
  }

  // 5. Intelligent Tabbing Order
  function buildLinearOrder(panel) {
    const sidebarBtns = Array.from(panel.querySelectorAll('.sidebar-link'));
    
    // CASE A: Panel has NO Sidebar (e.g. Categories) -> Just grab all links
    if (sidebarBtns.length === 0) {
      return Array.from(panel.querySelectorAll('a, button, input'));
    }

    // CASE B: Panel HAS Sidebar -> Order is Sidebar Item -> Associated Content -> Next Sidebar Item
    const order = [];
    sidebarBtns.forEach(catBtn => {
      order.push(catBtn); // 1. The sidebar button itself
      
      // 2. The links inside the visible content for this button
      if (catBtn.classList.contains('is-active')) {
        const key = catBtn.getAttribute('data-cat');
        const content = panel.querySelector(`.content-grid[data-content="${key}"]`) || panel.querySelector(`#content-${key}`);
        if (content) {
          order.push(...Array.from(content.querySelectorAll('a, button')));
        }
      }
    });

    // 3. Always add the global close button if it exists
    const closer = panel.querySelector('.mega-panel__close');
    if (closer) order.push(closer);
    
    return order;
  }

  // Trap/Guide Tab focus inside the open panel
  function handlePanelTabbing(e) {
    if (e.key !== 'Tab') return;
    const open = nav.querySelector('.mega-panel.is-open');
    if (!open) return;

    const seq = buildLinearOrder(open);
    if (!seq.length) return;

    const idx = seq.indexOf(document.activeElement);
    // If focus is not currently inside the calculated sequence, do nothing (let browser handle it)
    if (idx === -1) return;

    e.preventDefault();
    const dir = e.shiftKey ? -1 : 1;
    // Cyclic tabbing: Loop to start/end
    const nextElement = seq[(idx + dir + seq.length) % seq.length];
    nextElement.focus();
  }

  // =========================================================
  //  EVENT LISTENERS
  // =========================================================

  items.forEach(btn => {
    const panelId = btn.dataset.panel;

    const clearTimer = () => {
      const t = hoverTimers.get(btn);
      if (t) { clearTimeout(t); hoverTimers.delete(btn); }
    };

    // A. Mouse Hover: Open with delay
    btn.addEventListener('mouseenter', () => {
      clearTimer();
      if (btn.getAttribute('aria-expanded') !== 'true') {
        const t = setTimeout(() => openPanel(panelId, btn, { moveFocus: false }), HOVER_DELAY_MS);
        hoverTimers.set(btn, t);
      }
    });

    // B. Mouse Leave: Close if not entering panel
    btn.addEventListener('mouseleave', (e) => {
      clearTimer();
      const to = e.relatedTarget;
      const enteredPanel   = Array.from(panels).some(p => within(p, to));
      const enteredTrigger = Array.from(items).some(i => within(i, to));
      if (!enteredPanel && !enteredTrigger) closePanels({ returnFocus: false });
    });

    // C. Click / Enter Key: Toggle
    // (Browsers fire 'click' when pressing Enter on a button)
    btn.addEventListener('click', (e) => {
      if (btn.tagName === 'A') e.preventDefault(); // Stop link nav
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      expanded ? closePanels({ returnFocus: true }) : openPanel(panelId, btn, { moveFocus: true });
    });

    // D. Tab Key: Move INTO the panel
    btn.addEventListener('keydown', (e) => {
      if (e.key === 'Tab' && btn.getAttribute('aria-expanded') === 'true' && !e.shiftKey) {
        e.preventDefault();
        
        const panel = document.getElementById(panelId);
        if (panel) {
          // Find first sidebar link OR first general link (for Categories panel)
          const firstTarget = panel.querySelector('.sidebar-link.is-active') || 
                              panel.querySelector('.sidebar-link') ||
                              panel.querySelector('a, button:not(.mega-panel__close)');
          
          if (firstTarget) firstTarget.focus();
        }
      }
    });
  });

  // Panel Interactions
  panels.forEach(panel => {
    // Mouse leave panel
    panel.addEventListener('mouseleave', (e) => {
      const to = e.relatedTarget;
      const enteredTrigger = Array.from(items).some(i => within(i, to));
      if (!enteredTrigger) closePanels({ returnFocus: false });
    });

    // Sidebar Hover/Focus logic
    panel.addEventListener('mouseover', (e) => {
      const btn = e.target.closest('.sidebar-link'); if (btn) activateSidebar(btn);
    });
    panel.addEventListener('focusin', (e) => {
      const btn = e.target.closest('.sidebar-link'); if (btn) activateSidebar(btn);
    });

    // Close Button
    const closer = panel.querySelector('.mega-panel__close');
    if (closer) {
      closer.addEventListener('click', () => closePanels({ returnFocus: true }));
    }
  });

  // Global Inputs
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const open = nav.querySelector('.mega-panel.is-open');
      if (open) { e.preventDefault(); closePanels({ returnFocus: true }); }
    }
    handlePanelTabbing(e);
  });

  document.addEventListener('click', (e) => {
    if (!nav.contains(e.target)) closePanels();
  });

  // Init: ensure hidden/inert
  panels.forEach(p => {
    p.classList.remove('is-open');
    p.hidden = true;
    setPanelInert(p, true);
  });

})();